import { useCallback } from "react";
import { POSTHOG_EVENTS } from "../../../constants/PostHogEvents";
import { usePostHog } from "../../../hooks/usePostHog";
import { useAppStore } from "../../../hooks/useStores";

export const useFiboEditImageUpload = (jumpToSection?: (sectionId: string) => void) => {
	const { fiboStore, playgroundStore } = useAppStore();
	const { fiboEditStore } = fiboStore;
	const { trackEvent } = usePostHog();

	const handleUpload = useCallback(
		async (e: React.ChangeEvent<HTMLInputElement>) => {
			const file: File | undefined = e.target.files?.[0];
			if (!file) return;

			// Track image upload
			trackEvent(POSTHOG_EVENTS.FIBO_IMAGE_UPLOADED, {
				lab_variant: "FIBO-EDIT",
				file_size: file.size,
				file_type: file.type,
			});

			await fiboEditStore.updateImage(file);
			fiboEditStore.config.mask = undefined;

			if (fiboEditStore.config.image) {
				fiboEditStore.createUploadedImageGroup(fiboEditStore.config.image);

				const latestResult = playgroundStore.playgroundResults[playgroundStore.playgroundResults.length - 1];
				if (latestResult) {
					playgroundStore.selectedResult = latestResult;
					setTimeout(() => {
						jumpToSection?.(latestResult.id);
					}, 100);
				}
			}
		},
		[fiboEditStore, fiboStore, playgroundStore, jumpToSection, trackEvent],
	);

	return { handleUpload };
};
